const LINKED_LOCATION_PROFILES_PREFIX = 'location-details-linked-location-profiles'

export const linkedLocationProfilesHeapAttributes = {
  linkedLocationProfilesLinkButton: `${LINKED_LOCATION_PROFILES_PREFIX}-link-button`,
  linkedLocationProfilesUnlinkButton: `${LINKED_LOCATION_PROFILES_PREFIX}-unlink-button`,
}
